import { createFileRoute } from '@tanstack/react-router';
import { MentorPanel } from '@/components/coaching/MentorPanel';

export const Route = createFileRoute('/coaching/book')({
  component: MentorPanel,
});
